import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";

function Otrosin() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      {/* <BlogPostHeader /> */}
      <div className="main" style={{ marginTop: "8em" }}>
        <div className="section">
          <Container className="fluid">
            <Row>
                <Col md="12">
                  <Card style={{marginTop:"2%"}}>
                      <CardBody>
                        <center>
                          <iframe width="560" height="315" src="https://www.youtube.com/embed/V-nb0Y5haos" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </center>        
                      </CardBody>
                  </Card>
                </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Otrosin;
